export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";